import { List, Map } from "immutable";
import { loadedAsyncState, unloadedAsyncState } from "widgets-for-react";
import { FormAppState } from "../../../form/renderers";
import { FormState, FormData, FieldData } from "../../../form/types";
import moment from "moment"
import i18next from "i18next"
import { getStep1Data } from "./beslismatrixStep1PageState";
import { LoadFormData } from "../../../form";
import { getStep2Data } from "./beslismatrixStep2PageState";
import { getStep3Data } from "./beslismatrixStep3PageState";
import { getStep4Data } from "./beslismatrixStep4PageState";
import { get_all_fields } from "../../../form/utils";
import { reset_timer_state } from "./beslismatrixWizardWidget";
import { getAdviceUrl } from "./beslismatrixWizardApi";

export type BeslismatrixFormState = {
  FormState: FormAppState | "not-ready"
  RedirectLink: string
  IntroText: string
}

let loadForm = (): FormAppState => {
  reset_timer_state()
  let get_state = (): FormState => {

    let res: FormState = {
      form_submission_logic: unloadedAsyncState(),
      dirty: false,
      should_render_deps: true,
      extra_input_for_dependency_check: () => List(),
      dependencies_state: Map(),
      context: {
        external_options: Map<string, string[]>()
      },
      form_data: loadedAsyncState((() => {
        let formData: FormData = {
          form: {
            CreatedDate: moment(),
            Id: 1,
            description: "",
            remote_submission_link: "",
            store_submissions_locally: false,
            store_submissions_remote: false,
            title: i18next.t('Beslismatrix.Title'),
          },
          tabs: [
            {
              tab: { title: i18next.t('Tab1.Title'), CreatedDate: moment(), Id: 1, itemOrderNumber: 1 },
              sections: [
                { section: { CreatedDate: moment(), Id: 1, itemOrderNumber: 1, reviewed: true, title: "" }, steps: getStep1Data() }
              ]
            },
            {
              tab: { title: i18next.t('Tab2.Title'), CreatedDate: moment(), Id: 2, itemOrderNumber: 2 },
              sections: [
                { section: { CreatedDate: moment(), Id: 1, itemOrderNumber: 1, reviewed: true, title: "" }, steps: getStep2Data() }
              ]
            },
            {
              tab: { title: i18next.t('Tab3.Title'), CreatedDate: moment(), Id: 3, itemOrderNumber: 3 },
              sections: [
                { section: { CreatedDate: moment(), Id: 1, itemOrderNumber: 1, reviewed: true, title: "" }, steps: getStep3Data() }
              ]
            },
            {
              tab: { title: i18next.t('Tab4.Title'), CreatedDate: moment(), Id: 4, itemOrderNumber: 4 },
              sections: [
                { section: { CreatedDate: moment(), Id: 1, itemOrderNumber: 1, reviewed: true, title: "" }, steps: getStep4Data() }
              ]
            }
          ],
          tags: [],
          latest_submission: undefined,
          steps: [],
          thank_you: {
            CreatedDate: moment(),
            Id: 1,
            content: ""
          }
        }

        return formData
      })())
    }
    return res

  }
  let state1 = LoadFormData(a => a, get_state(), undefined)

  return {
    formState: state1,
    submittedData: unloadedAsyncState(),
    sectionId: 1,
    tabId: 1
  }
}

export let initBeslismatrixFormState = (): BeslismatrixFormState => ({
  FormState: loadForm(),
  RedirectLink: "",
  IntroText: undefined
})


export let form_state_to_key_vaule_pair = (state: FormState): { field_name: string, field_value: string, is_sector_field: boolean, is_email: boolean }[] => {
  let res: Map<string, FieldData> = Map()
  if (state.form_data.kind != "loaded") return []
  state.form_data.value.tabs.forEach(t => {
    t.sections.forEach(se => {
      se.steps.forEach(st => {
        st.fields.forEach(f => {
          res = res.set(f.field.label, f)
        })
      })
    })
  })


  let res1 = res.map((value, key) => {
    return {
      field_name: key,
      field_value: value.user_input || "",
      is_email: value.field.Kind == "UserEmail",
      is_sector_field: value.field.title.toLowerCase() == (i18next.t('Tab1.Q1') || "").toLowerCase(),
    }
  }).valueSeq().toArray()

  return res1
}


export let redirect_logic = (s1: BeslismatrixFormState, s2: BeslismatrixFormState): BeslismatrixFormState => {
  let all_fields = Map<number, FieldData>()
  if (s2.FormState != 'not-ready')
    get_all_fields(s2.FormState.formState).map(f => {
      all_fields = all_fields.set(f.field.Id, f)
    })

  let redirectForLastTab = (prev_tab: number, current_tab: number): string | undefined => {
    if (!(prev_tab == -1 && current_tab == -1)) return undefined
    let q1 = all_fields.get(1)
    let q3 = all_fields.get(3) // Employee count field
    debugger
    return getAdviceUrl(q1.user_input.toLowerCase(), q3.user_input.toLowerCase())
  }

  if (s1.FormState != 'not-ready' && s2.FormState != 'not-ready') {
    s2.RedirectLink = redirectForLastTab(s1.FormState.tabId, s2.FormState.tabId)

    if (s2.RedirectLink != undefined && s2.RedirectLink != "") {
      s2.IntroText = 'Beslismatrix.Success_Text'
      s2.FormState = 'not-ready'
    }
  }
  return s2

}